import React, { Component } from 'react';
import { capitalizeAndParse, capitalizeAndParseCamel } from '../shared/utils';
class Portfolio extends Component {
  render() {
    const baseImagePath = this.props.imagePath ? this.props.imagePath: 'images/portfolio/';
    let useList = false;
    let useFile = false;
    //console.log(this.props.data)
    if(this.props.data){
      var projects;
      if(this.props.data.projects){
        projects = this.props.data.projects.map(function(projects){
          var projectImage = baseImagePath+projects.image;
          const path = '/' + projects.category + '/' + projects.title;
          // console.log(`${path} - path`)
          if(projects.url) {
            //console.log(`url! --- \n${projects.url}`)
          } else {
            projects.url = path;
            // console.log(projects)
            // console.log('no url--', path )
          }
          //console.log(projects.category, '/', projects.title)
  
          const showSVG = projectImage.includes('/coding.png');
          return <div key={projects.title} className="columns portfolio-item">
             {/* {projects.title} */}
             <div className="item-wrap">
              <a href={projects.url} title={projects.title}>
                 {/* <img alt={projects.title} src={projectImage} /> */}
  
                {showSVG ?
                  <div className="svg-wrap">
                  <img alt={projects.title} src={projectImage} />
                  {capitalizeAndParse(projects.title)}&nbsp;&nbsp;
  
                  {/* <svg height="20" width="200">
                  <rect width="300" fill="yellow" opacity="10%"/>
                  <circle cx="100" cy="87.5" r="90" stroke="orange" stroke-width="1" fill="white" />
  
                  <text x="75" y="10"  alignmentBaseline='central' fill="black">
                    
                  {capitalizeAndParse(projects.title)}&nbsp;&nbsp;
                    </text>
                      Sorry, your browser does not support inline SVG.
                  </svg> */}
                  </div>
                : 
                <img alt={projects.title} src={projectImage} />
  
                }
                 <div className="overlay">
                    <div className="portfolio-item-meta">
                   <h5>{projects.title}</h5>
                       <p>{projects.category}</p>
                    </div>
                  </div>
                <div className="link-icon"><i className="fa fa-link"></i></div>
              </a>
            </div>
          </div>
        })
      } else {
        if(this.props.fileContent){
          useFile = true;
          projects = 
          <div>
            <a href=".." className="file-back">Back</a>
            <div className='file-box-wrapper'>
              <div className="file-box">{this.props.fileContent}</div>
            </div>
          </div>
        } else {
          useList = true;
          projects = this.props.data.map((file) => {
            console.log(file)
            const path = `${baseImagePath}/${file.name}`
            return <li key={file.name} className="portfolio-item"><a href={path} title={file.name}>{capitalizeAndParseCamel(file.name)}</a></li>        
            })
          }
      }
    }

    return (
      <section id="portfolio">

      <div className="row">

         <div className="twelve columns collapsed">

            <h1>{this.props.header}</h1>
            {useList ? <ul className="practice-file-list">{projects}</ul>:
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
              {projects}
            </div>}
          </div>
      </div>
   </section>
    );
  }
}

export default Portfolio;
